import { EventOutreachSchemaType } from "../../List/schema/list";
import { isEventVariableKey } from "../../Messages/components/Variables/utils/variableRows";

/** One row the TinyMCE `{` autocompleter can offer: the pill label and the token key. */
export interface VariableSuggestion {
	text: string;
	value: string;
}

/**
 * Result cap for the `{` autocompleter. TinyMCE's default is ten, and the catalogue lists
 * about forty prospect keys before the event-outreach tokens are appended — so with the
 * default cap a plain `{` could never reach an event variable (PREC-4010).
 */
export const VARIABLE_AUTOCOMPLETE_MAX_RESULTS = 200;

/**
 * Every event-outreach token also answers to the word "event", so `{event` lists the whole
 * group — Meeting Location, Meeting Link and the list's custom variables included. Without
 * this only the three tokens whose label happens to contain "event" appear, and a user who
 * named a custom variable "Stand 1" concludes it does not exist (PREC-4010).
 */
const EVENT_GROUP_ALIAS = "event";

/**
 * The autocompleter's match: label or token key contains the typed text, case-insensitively,
 * or the text is a prefix of "event" and the token is an event-outreach variable.
 */
export const filterVariableSuggestions = (
	suggestions: VariableSuggestion[],
	pattern: string,
	listEvent?: EventOutreachSchemaType | null
): VariableSuggestion[] => {
	const needle = pattern.trim().toLowerCase();

	if (!needle) {
		return suggestions;
	}

	const matchesEventGroup = EVENT_GROUP_ALIAS.startsWith(needle);

	return suggestions.filter(
		(suggestion) =>
			suggestion.text.toLowerCase().includes(needle) ||
			suggestion.value.toLowerCase().includes(needle) ||
			(matchesEventGroup && isEventVariableKey(suggestion.value, listEvent))
	);
};
